import { Printer, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function CareCard() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background py-10 px-4 flex flex-col items-center">
      <style>{`
        @media print {
          .no-print { display: none !important; }
          body { background: #fff !important; }
          .care-card { box-shadow: none !important; border: 1px solid #e7ddce !important; margin: 0 !important; }
        }
      `}</style>

      <div className="no-print w-full max-w-md flex items-center justify-between mb-8">
        <button data-testid="care-card-back" onClick={() => navigate(-1)} className="flex items-center gap-2 text-sm text-muted-foreground hover:text-gold">
          <ArrowLeft size={16} /> Back
        </button>
        <button data-testid="care-card-print" onClick={() => window.print()}
          className="flex items-center gap-2 bg-gold text-primary-foreground px-5 py-2.5 text-xs font-mono uppercase tracking-widest hover:bg-gold-hover">
          <Printer size={15} /> Print Card
        </button>
      </div>

      <div className="care-card bg-white text-[#2b2724] w-full max-w-md border border-[#e7ddce] shadow-lg p-10 text-center" data-testid="care-card">
        <p className="font-script text-5xl text-[#c79a3a] mb-1">Ke-Sa</p>
        <p className="text-[10px] tracking-[0.3em] uppercase text-[#998f80] mb-8">Handcrafted Jewellery</p>

        <h1 className="font-serif text-2xl mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Caring for your piece</h1>

        <ul className="text-left text-sm space-y-3" style={{ color: '#5a5248' }}>
          <li>✦ Your piece is <strong>gold-plated brass</strong>, finished by hand.</li>
          <li>✦ Keep it <strong>dry</strong> — remove before showering, swimming or exercise.</li>
          <li>✦ Apply perfume, lotion and hairspray <strong>before</strong> putting it on.</li>
          <li>✦ Store in the pouch provided, away from humidity.</li>
          <li>✦ Buff gently with a <strong>soft, dry cloth</strong> to restore shine.</li>
          <li>✦ Never use chemical or abrasive polishes.</li>
        </ul>

        <div className="mt-8 pt-6 border-t border-[#e7ddce] text-xs text-[#998f80]">
          <p>Thank you for choosing Ke-Sa.</p>
          <p className="mt-1">@_ke_sa · +971 52 357 7644</p>
        </div>
      </div>

      <p className="no-print text-xs text-muted-foreground mt-6 max-w-md text-center">
        Print this card and slip it into each order, or hand it to customers with their piece.
      </p>
    </div>
  );
}
